import { render, staticRenderFns } from "./TabDatosGenerales.vue?vue&type=template&id=ef841608"
import script from "./TabDatosGenerales.vue?vue&type=script&lang=js"
export * from "./TabDatosGenerales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef841608')) {
      api.createRecord('ef841608', component.options)
    } else {
      api.reload('ef841608', component.options)
    }
    module.hot.accept("./TabDatosGenerales.vue?vue&type=template&id=ef841608", function () {
      api.rerender('ef841608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabDatosGenerales.vue"
export default component.exports